export default "__VITE_ASSET__D3sBhRRg__"